import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import CoreFilter from "./CoreFilter";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

const styles = (theme) => ({
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexGrow: 1,
  },
});
export class FilterNotifications extends Component {
  render() {
    const { classes, t, expanded } = this.props;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {this.props.filter !== null && (
          <div>
            {this.props.showReset && (
              <div>
                <Button
                  className={classes.resetButton}
                  onClick={this.props.resetToDefaultFilters}
                >
                  <Trans i18nKey="filters_reset_to_default" />
                </Button>
              </div>
            )}
            <div
              className={classes.filterWrapper}
              style={{ flexDirection: this.props.isMobile && "column" }}
            >
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.filter.onlyUnread}
                      onChange={this.props.handleCheckboxChange("onlyUnread")}
                      value="unread"
                    />
                  }
                  label={t("notifications_filter_only_unread")}
                />
              </div>
              <div>
                <FormControlLabel
                  key={"onlyMine"}
                  control={
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="notificationType">
                        <Trans i18nKey="filter_notifications_type">
                          filter_notifications_type
                        </Trans>
                      </InputLabel>
                      <Select
                        value={this.props.filter.notificationType}
                        onChange={this.props.handleSelectChange}
                        inputProps={{
                          name: "notificationType",
                          id: "notificationType",
                        }}
                      >
                        <MenuItem value="ALL">
                          <Trans i18nKey="filter_notifications_all">
                            filter_notifications_all
                          </Trans>
                        </MenuItem>
                        <MenuItem value="MESSAGE">
                          <Trans i18nKey="filter_notifications_messages">
                            filter_notifications_messages
                          </Trans>
                        </MenuItem>
                        <MenuItem value="ALERTS">
                          <Trans i18nKey="filter_notifications_alerts">
                            filter_notifications_alerts
                          </Trans>
                        </MenuItem>
                        <MenuItem value="REQUIRED_READING">
                          <Trans i18nKey="filter_notifications_required_reading">
                            filter_notifications_required_reading
                          </Trans>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  }
                  label={t("filter_notifications_type_label")}
                />
                {/* <Trans i18nKey="filter_notifications_type_label" />
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="notificationType">
                    <Trans i18nKey="filter_notifications_type">
                      filter_notifications_type
                    </Trans>
                  </InputLabel>
                  <Select
                    value={this.props.filter.notificationType}
                    onChange={this.props.handleSelectChange}
                    inputProps={{
                      name: "notificationType",
                      id: "notificationType",
                    }}
                  >
                    <MenuItem value="all">
                      <Trans i18nKey="filter_notifications_all">
                        filter_notifications_all
                      </Trans>
                    </MenuItem>
                    <MenuItem value="messages">
                      <Trans i18nKey="filter_notifications_messages">
                        filter_notifications_messages
                      </Trans>
                    </MenuItem>
                    <MenuItem value="alerts">
                      <Trans i18nKey="filter_notifications_alerts">
                        filter_notifications_alerts
                      </Trans>
                    </MenuItem>
                    <MenuItem value="required_reading">
                      <Trans i18nKey="filter_notifications_required_reading">
                        filter_notifications_required_reading
                      </Trans>
                    </MenuItem>
                  </Select>
                </FormControl> */}
              </div>
            </div>
          </div>
        )}
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterNotifications))));
